import React, { useEffect, useState } from "react";
import "./styles.css";
import { Breadcrumb, PopUpModal, TextInput, Title } from "../../Components/Atoms";
import PATH from "../../Routes/paths";
import { Button } from "@chakra-ui/react";
import { mapDeviceToVehicle } from "../../APIs";
import { CircledCheckIcon } from "../../Assets/images/svgs";
import { useNavigate } from "react-router-dom";
import PATHS from "../../Routes/paths";

const initialState = {
  chassisNo: "",
  registrationNo: "",
};

const MapToVehicle = () => {
  const [imei, setImei] = useState("");
  const [formData, setFormData] = useState(initialState);
  const [formErrors, setFormErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const navigate = useNavigate();

  const paths = [
    { idx: 0, name: "Inventory Management", link: PATH.INVENTORY_OVERVIEW },
    { idx: 1, name: "Map Device", link: "", isCurrentPage: true },
  ];

  const setFormFieldData = (key) => (value) => {
    setFormErrors({ [key]: "" });
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleMapDevice = () => {
    const errors = {};
    if (!formData.chassisNo) errors.chassisNo = "Chassis No is required";

    if (errors.chassisNo) return setFormErrors(errors);

    let vehicle = { imei: imei, chNum: formData.chassisNo };
    if(formData.registrationNo){
      vehicle.reg = formData.registrationNo;
    }

    mapDeviceToVehicle({ vehicles: [vehicle] }, (err) => {
      if (err) console.error(err);
      else {
        setShowSuccessModal(true);

        setTimeout(() => {
          navigate(`${PATHS.INVENTORY_OVERVIEW}/${PATHS.SPECIFIC_DEVICE}?imei=${imei}`);
        }, 2000)
      }
    });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const imeiNo = searchParams.get("imei");
    setImei(imeiNo);
  }, []);

  useEffect(() => {
    if (formData.chassisNo) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [formData]);

  const getSuccessModalBody = () => {
    return (
      <div>
        <div className="device-mapped-success">
          <CircledCheckIcon />
          <p>Device mapped to vehicle successfully</p>
        </div>
      </div>
    )
  }

  return (
    <div className="map-device">
      <div className="breadcrumb-container">
        <Breadcrumb paths={paths} />
      </div>

      <div className="map-device-content">
        <div className="title-container">
          <Title>Map Device To Vehicle</Title>
        </div>

        <div className="device-imei">
          <p>
            <span className="key">Device IMEI:</span>
            <span className="value">{imei}</span>
          </p>
        </div>

        <div className="map-device-form">
          <div className="form-head">
            <h3>Vehicle Details</h3>
            <hr />
          </div>
          <div className="form-fields">
            <TextInput
              inputName="chassisNo"
              placeholder="Enter Chassis Number"
              className="chassis-no"
              label="Chassis No"
              labelClassName="chassis-no-label"
              errMessage={formErrors.chassisNo || ""}
              onChange={setFormFieldData("chassisNo")}
              value={formData.chassisNo}
              isRequired={true}
              disabled={false}
            />

            <TextInput
              inputName="registrationNo"
              placeholder="Enter Registration Number"
              className="internal-id"
              label="Registration Number"
              labelClassName="internal-id-label"
              errMessage={formErrors.registrationNo || ""}
              onChange={setFormFieldData("registrationNo")}
              value={formData.registrationNo}
              isRequired={false}
              disabled={false}
            />
          </div>
        </div>
      </div>

      <div className="button-container">
        <Button
          className={isDisabled === true ? "disabled-btn" : "map-btn"}
          onClick={handleMapDevice}
        >
          Map Device
        </Button>
      </div>

      <PopUpModal open={showSuccessModal} modalMsg={getSuccessModalBody()} onModalClose={() => {}} darken />
    </div>
  );
};

export default MapToVehicle;
